import { algoliasearch } from 'algoliasearch'

import {
  ALGOLIA_API_KEY,
  ALGOLIA_APP_ID,
  isAlgoliaIntegrationConfigured
} from 'lib/algolia/config'

// Algolia initialization - clients are initialized lazily when requests are about to be made.
let algoliaSearchClient: ReturnType<typeof algoliasearch> | null = null

let algoliaRecommendationClient: ReturnType<
  ReturnType<typeof algoliasearch>['initRecommend']
> | null = null

export const initializeAlgoliaClients = () => {
  if (!isAlgoliaIntegrationConfigured) return false

  algoliaSearchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

  algoliaRecommendationClient = algoliaSearchClient.initRecommend()

  return true
}

export const getAlgoliaClient = () => {
  if (!algoliaSearchClient || !algoliaRecommendationClient) {
    initializeAlgoliaClients()
  }

  return {
    search: algoliaSearchClient,
    recommend: algoliaRecommendationClient
  }
}
